import client from './client';

export const listUsers = () =>
  client.get('/api/users').then(r => r.data);

export const getLinkableEmployees = () =>
  client.get('/api/users/linkable-employees').then(r => r.data);

export const createUser = (data) =>
  client.post('/api/users', data).then(r => r.data);

export const updateUser = (id, data) =>
  client.patch(`/api/users/${id}`, data).then(r => r.data);

export const deleteUser = (id) =>
  client.delete(`/api/users/${id}`).then(r => r.data);

export const patchUser = (id, data) =>
  client.patch(`/api/users/${id}`, data).then(r => r.data);

export const toggleHseTraining = (companyId, enabled) =>
  client.put(`/api/users/companies/${companyId}/hse-toggle`, { enabled }).then(r => r.data);
